// Local-calendar date helpers. NEVER use d.toISOString().slice(0, 10) for a calendar date:
// toISOString() converts to UTC, and in NZ daylight time (UTC+13) every local time before
// 1pm lands on the previous UTC day (local noon -> 23:00Z the day before).
const pad = (n) => String(n).padStart(2, "0");

// The system runs on New Zealand time whatever the device's own time zone says (a tablet or computer set to the wrong zone would otherwise show the wrong "today").
// nzNow() is a Date whose local fields (getFullYear, getHours...) read as the current New Zealand wall-clock time: use it wherever the code means "now" or "today".
const NZ_PARTS = new Intl.DateTimeFormat("en-CA", { timeZone: "Pacific/Auckland", hourCycle: "h23", year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit", second: "2-digit" });
export const nzNow = () => {
  const p = {}; NZ_PARTS.formatToParts(new Date()).forEach((x) => { p[x.type] = x.value; });
  return new Date(+p.year, +p.month - 1, +p.day, +p.hour, +p.minute, +p.second);
};

/** YYYY-MM-DD of a Date (defaults to today in New Zealand). */
export const isoDate = (d = nzNow()) => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
/** Local YYYY-MM of a Date (defaults to now). */
export const isoMonth = (d = nzNow()) => isoDate(d).slice(0, 7);
/** Local YYYY-MM-DD -> Date at local noon (safe from DST edges). */
export const parseIso = (s) => { const [y, m, d] = String(s).slice(0, 10).split("-").map(Number); return new Date(y, (m || 1) - 1, d || 1, 12, 0, 0, 0); };
/** Add n days to a Date (local). */
export const addDays = (d, n) => { const x = new Date(d); x.setDate(x.getDate() + n); return x; };
/** Add n days to a YYYY-MM-DD string. */
export const addDaysIso = (s, n) => isoDate(addDays(parseIso(s), n));
/** Monday (local noon) of the week containing d. */
export const mondayOf = (d = nzNow()) => { const x = new Date(d); x.setHours(12, 0, 0, 0); x.setDate(x.getDate() - ((x.getDay() + 6) % 7)); return x; };
/** Add n months to a YYYY-MM-DD string, clamped to the month length. */
export const addMonthsIso = (s, n) => {
  const d = parseIso(s); const day = d.getDate();
  d.setDate(1); d.setMonth(d.getMonth() + n);
  const last = new Date(d.getFullYear(), d.getMonth() + 1, 0).getDate();
  d.setDate(Math.min(day, last));
  return isoDate(d);
};
